<section id="news-search" class="gap-container">
  <div class="header">
    <app-display-large>{{ "NewsTitle" | translate }}</app-display-large>
  </div>

  <div class="search-container-wrapper" *ngIf="!loading; else loadingTemplate">
    <div class="content">
      <ng-container *ngIf="!loadingNews; else loadingTemplate">
        <div class="results-info" *ngIf="searchQuery">
          <div>
            <p class="results-info-title">
              {{ "SearchResultsFor" | translate : { totalItems: totalItems } }}
            </p>
            <p class="results-info-query">
              {{ searchQuery }}
            </p>
          </div>
          <div>
            <app-input-dropdown
              class="sort-by-dropdown"
              [title]="sortBy.label | translate"
              [matMenuTriggerFor]="menu"
            >
              <mat-menu #menu="matMenu" classList="drop-btn-menu">
                <button
                  mat-menu-item=""
                  [id]="itemMenu.label"
                  (click)="sortNewsBy(itemMenu)"
                  *ngFor="let itemMenu of itemsMenu"
                >
                  {{ itemMenu.label | translate }}
                </button>
              </mat-menu>
            </app-input-dropdown>
          </div>
        </div>

        <ng-container *ngIf="!sortingNews; else loadingTemplate">
          <div
            *ngIf="!loadingPagination; else loadingTemplate"
            class="news-grid"
          >
            <div *ngFor="let item of news" class="news-item full">
              <card-news
                [news]="item"
                [isSearchResult]="true"
                (clickNews)="goToNews($event)"
              ></card-news>
            </div>
          </div>
          <div class="no-results" *ngIf="news.length === 0">
            <span *ngIf="searchQuery">{{ "Noresult" | translate }}</span>
            <span *ngIf="!searchQuery">{{
              "No news available" | translate
            }}</span>
          </div>

          <div class="paginator-container" *ngIf="totalItems > 0">
            <div class="simple-paginator">
              <mat-select
                [value]="pageSize"
                (selectionChange)="onPageSizeChange($event.value)"
              >
                <mat-option
                  *ngFor="let size of pageSizeOptions"
                  [value]="size"
                  >{{ size }}</mat-option
                >
              </mat-select>

              <span class="paginator-range">
                {{
                  "PaginatorRange"
                    | translate
                      : { start: rangeStart, end: rangeEnd, total: totalItems }
                }}
              </span>

              <button
                mat-icon-button
                [disabled]="currentPage === 0"
                (click)="previousPage()"
              >
                <mat-icon>chevron_left</mat-icon>
              </button>
              <button
                mat-icon-button
                [disabled]="isLastPage()"
                (click)="nextPage()"
              >
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="search-container">
      <app-search-input
        theme="light"
        searchMode="manual"
        [initialValue]="searchQuery"
        (onSearch)="onSearchChange($event)"
      ></app-search-input>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>
</section>
